import { useSelector } from 'react-redux'

import props from '../../../redux/props'
import Floor from './Floor'
import { getUUID } from '../../../utility'
import Upsert from './Upsert'
import { Floor as FloorType } from '../../../types/Survey/Survey'

type Props = {
  value: FloorType[]
  onChange: (value: FloorType[]) => void
  invert?: boolean
}

const FloorManager: React.FC<Props> = ({ value, onChange, invert = false }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const update = (uuid: string) => (floor: FloorType) => {
    onChange(value.map((p) => (p.uuid === uuid ? floor : p)))
  }

  const add = (floor: FloorType) => {
    if (Array.isArray(value)) {
      onChange([...value, floor])
    } else {
      onChange([floor])
    }
  }

  const remove = (uuid: string) => () => {
    if (Array.isArray(value)) {
      onChange(value.filter((p) => p.uuid !== uuid))
    }
  }

  return (
    <div className="mt-1">
      <div>
        <div className="flex flex-row items-center justify-between">
          <div className={invert ? 'text-white text-sm' : 'text-gray text-sm'}>{t.UI.floorManager.title}</div>
          <Upsert invert={invert} callback={add} />
        </div>
        <div className="mt-2 mb-5">
          {Array.isArray(value) && value.length > 0 && (
            <div className="mb-1">
              {value.map((p, i) => (
                <Floor invert={invert} key={getUUID()} data={p} removeCallback={remove(p.uuid)} updateCallback={update(p.uuid)} />
              ))}
              {Array.isArray(value) && value.length > 0 && (
                <div className={` ${invert ? 'text-white' : 'text-gray'}`}>
                  {`= ${value.reduce((acc, floor) => acc + (floor.squareMeter || 0), 0)} ${t.generic.squareMeterSuffix}`}
                </div>
              )}
            </div>
          )}
          {(!Array.isArray(value) || value.length === 0) && (
            <div className={`text-sm text-center ${invert ? 'text-white' : 'text-gray'}`}>{t.UI.floorManager.empty}</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default FloorManager
